import ReactGA from "react-ga4";
import { extractDomain } from "./helper";

export const GA_MEASUREMENT_ID = "G-KXBZEW00DF";

export function trackPageView(path) {
  try {
    ReactGA.send({ hitType: "pageview", page: path });
  } catch {
    // non-blocking
  }
}

function normalizeEventParams(params = {}) {
  const payload = { ...params };

  if (payload.url) {
    const domain = extractDomain(payload.url);
    if (domain) payload.domain = domain;
    delete payload.url;
  }

  return payload;
}

export function trackEvent(name, params = {}) {
  try {
    ReactGA.event(name, normalizeEventParams(params));
  } catch {
    // non-blocking
  }
}

export const AnalyticsEvents = {
  TEST_STARTED: "test_started",
  TEST_COMPLETED: "test_completed",
  TEST_FAILED: "test_failed",
  AI_TOGGLED: "ai_suggestions_toggled",
  SHEET_SAVE: "sheet_save",
  SHARE_REPORT: "share_report",
  SIGNUP: "signup",
  LOGIN: "login",
};
